import './App.css';
import Terminal from './Terminal';

function App() {
  return (
    <div>
      <Terminal/>
    </div>
  );
  
}

export default App;
